module.exports = __webpack_public_path__ + "static/img/7.3939c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Text/7.png
// module id = 354
// module chunks = 0